import '../math/Graph.js';
import { Point } from '../math/Shapes.js';
import { Matrix } from '../math/Matrix.js';
import { Rotation } from './Rotation.js';
import { Scale } from './Scale.js';
import { Translation } from './Translation.js';

class CompositeTransform {
    constructor(x, y, scaleX, scaleY, angle, center) {
        this.translate = new Translation(x, y);
        if (scaleX !== undefined && scaleY !== undefined) {
            this.scale = new Scale(scaleX, scaleY);
        }
        if (angle !== undefined) {
            this.rotate = center ? new Rotation(angle, center.x, center.y) : new Rotation(angle);
        }
    }
    toString() {
        const toString = function (transform) {
            return transform ? transform.toString() : '';
        };
        return toString(this.translate) +
            toString(this.rotate) +
            toString(this.scale);
    }
    render(visual) {
        visual._transform = this;
        visual._renderTransform();
    }
    toMatrix() {
        let m = Matrix.unit();
        if (this.translate) {
            m = m.times(this.translate.toMatrix());
        }
        if (this.rotate) {
            m = m.times(this.rotate.toMatrix());
        }
        if (this.scale) {
            m = m.times(this.scale.toMatrix());
        }
        return m;
    }
    invert() {
        const rotate = this.rotate ? this.rotate.invert() : undefined, rotateMatrix = rotate ? rotate.toMatrix() : Matrix.unit(), scale = this.scale ? this.scale.invert() : undefined, scaleMatrix = scale ? scale.toMatrix() : Matrix.unit();
        let translatePoint = new Point(-this.translate.x, -this.translate.y);
        translatePoint = rotateMatrix.times(scaleMatrix).apply(translatePoint);
        const translate = new Translation(translatePoint.x, translatePoint.y);
        const transform = new CompositeTransform();
        transform.translate = translate;
        transform.rotate = rotate;
        transform.scale = scale;
        return transform;
    }
}

export { CompositeTransform };
